<template>
  <ppt-slide-viewer module-code="sjq_jm" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "SjqJm",
  components: { PptSlideViewer }
};
</script>
